module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightpartcloud-72af040454a732f83335d0b750eb268b.webp";